"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A parent class for all errors thrown by Parjs.
 */
class ParjsError extends Error {
    constructor() {
        super(...arguments);
        this.name = this.constructor.name;
    }
}
exports.ParjsError = ParjsError;
/**
 * An error that is thrown when it is assumed a parser will succeed, but it fails.
 */
class ParjsParsingFailure extends ParjsError {
    constructor(failure) {
        super(`Expected parsing to succeeded, but it failed. Reason: ${failure.trace.reason}`);
        this.failure = failure;
    }
}
exports.ParjsParsingFailure = ParjsParsingFailure;
/**
 * An error thrown to indicate that a parser has been constructed inappropriately.
 */
class ParserDefinitionError extends ParjsError {
    constructor(parserName, message) {
        super(message);
        this.parserName = parserName;
    }
}
exports.ParserDefinitionError = ParserDefinitionError;
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/errors.js
// module id = 95
// module chunks = 0 1